import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CaseService } from '../_services/case.service';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment';
import { FormatService } from '../_services/format.service';
import { OrderByPipe } from 'ngx-pipes';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
  providers: [ CaseService, FormatService, DatePipe, OrderByPipe ]
})
export class WelcomeComponent implements OnInit {

  allSurveys: any;
  survey;
  error;
  nextCaseCode: string;
  submissionCode: Array<number> = [];
  organisationCode: Array<number> = [];

  iePrompt: boolean = false;
  referralSource: string = 'link';
  isLive: boolean;
  bypassWelcome: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cases: CaseService,
    private format: FormatService,
    private date: DatePipe,
    private order: OrderByPipe
  ) {}

  ngOnInit() {
    // Check live/test
    if (environment.production) {
      this.isLive = true;
    } else {
      this.isLive = false;
    }

    // Check browser compatibility
    const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    if (isIEOrEdge === true) {
      // Block < IE11
      let browserVersion = this.getBrowser();
      if (browserVersion.version !== '11') {
        this.iePrompt = true;
      }
    }

    // Set survey
    let type = this.route.snapshot.paramMap.get('type');
    let id = this.route.snapshot.paramMap.get('id');

    this.getAllSurveys(type, id);


    let bypassWelcome = this.route.snapshot.queryParamMap.get('bypassWelcome');
    if (!bypassWelcome) {
      this.bypassWelcome = false;
    }

  }

  getAllSurveys(type?: string, id?: string) {
    this.cases.getSurveys().subscribe(
      success => {
        let surveys = [];
        
        success.data.projectSurveys.forEach(survey => {
          let formattedSurvey = this.format.mapSurveyData(survey)
          surveys.push(formattedSurvey);
        })

        // Reorder by surveyId
        // TODO: Add displaySequence to database
        surveys = this.order.transform(surveys, 'surveyId');
        
        this.getSurveySettings(surveys, type, id);
      },
      error => {
        this.error = 'This link is no longer available.';
        console.log(error);
      }
    )
  }

  getSurveySettings(surveys: any, type?: string, id?: string) {

    let surveyCount = surveys.length;
    let counter = 0;

    // Get survey settings
    // TODO: Add introShort and logoPath to /surveys end-point and remove need for loop
    surveys.forEach(survey => {
      this.cases.getSurveySettings(survey.surveyId).subscribe(
        success => {
          counter = counter + 1;
          success.data.surveySettings.forEach(setting => {
            let settingValue = setting.settingValue == 'true' || setting.settingValue == 'false' || setting.settingValue == 'null' ? JSON.parse(setting.settingValue) : setting.settingValue;
            survey[setting.settingName] = settingValue;
          });

          if (counter == surveyCount) {
            // Set all surveys (put open ones at the top)
            this.allSurveys = surveys.sort((a, b) => { return b.open - a.open });

            // Get specific survey
            if (type) {
              this.getSurvey(surveys, type, id);
            }
          }

        },
        error => {
          this.error = 'This link is no longer available.';
          console.log(error);
        }
      )
    });

  }

  getSurvey(surveys, type, id) {
    let survey = surveys.filter(s => s.surveyCode === type.toUpperCase())[0];
    
    // If type exists use the case code and get/set
    // the survey to sessionStorage, then get next case code
    if (survey && survey.open) {
      this.survey = survey;
      this.survey.surveyIntroButton = 'Continue to Survey'

      sessionStorage.setItem('survey', JSON.stringify(survey));
      this.responseCountCheck(survey, type, id);
    } else {
      this.error = "This survey is not currently live. It opens on " + this.date.transform(survey.openDt, 'dd-MM-yyyy') + ' and closes on ' + this.date.transform(survey.closeDt, 'dd-MM-yyyy') + '.'
    }
  }

  startSurvey(surveyCode) {
    let idPart1 = document.getElementsByClassName(surveyCode + '-1')[0]['value'],
        idPart2 = document.getElementsByClassName(surveyCode + '-2')[0]['value'];

    // Switch referral course to code
    this.referralSource = 'code';

    this.getSurvey(this.allSurveys, surveyCode.toLowerCase(), idPart1 + '-' + idPart2);
  }


  responseCountCheck(survey, type, id) {
    let submissionId = id.split('-')[0];
    let prefix = type.toUpperCase();
    
    // Check responses have not reached max. response count, if set
    if (survey.maxResponses) {
      this.cases.caseCodeCount(submissionId, prefix).subscribe(
        r => { 
          let count = r.data.count;
          if (count >= +survey.maxResponses) {
            this.error = "Thank you for your interest in taking part, but this survey has now reached the maximum number of responses permitted."
          } else {
            this.nextCase(type, id, survey.groupLevelId);
          }
         },
        e => { 
          console.log(e);
          this.error = "It has not been possible to check the status of this survey. Please contact support."
        }
      )
    } else {
      this.nextCase(type, id, survey.groupLevelId);
    }
  }

  nextCase(type, id, groupLevelId) {
    this.cases.nextCase(type.toUpperCase(), id.split('-')[0], id.split('-')[1]).subscribe(
      r => {
        let nextCase = r.data.caseCode;
        if (nextCase) {
          this.nextCaseCode = nextCase;
        } else {
          this.error = 'This link is no longer available.';
        }

        // Bypass welcome
        if (this.bypassWelcome) {
          this.newCase(nextCase, groupLevelId);
        }
      },
      e => { 
        this.error = 'This link or code is not correct. Please double-check it or contact support.';
        console.log(e);
      }
    )
  }
  
  async newCase(nextCase, groupLevelId) {
    nextCase = nextCase.split('-');

    // Add meta-data to case code
    let note = {
      referralSource: this.referralSource,
      browser: this.getBrowser(),
      language: 'english',
      // ip: await this.getIPAddress()
    }
    
    let caseCodeNote = JSON.stringify(note).substring(0,190);

    this.cases.newCase(nextCase[0], +nextCase[2], +nextCase[3], nextCase[4], caseCodeNote, groupLevelId).subscribe(
      r => { 
        let caseCode = r.data.caseCode.toLowerCase();
        this.router.navigate(['/survey/', caseCode], { queryParams: { bypassWelcome: null }, queryParamsHandling: 'merge' });
      },
      e => { 
        console.log('It was not possible to create a new case', e)
      }
    )
  }

  getBrowser() {
    var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []; 
    
    if (/trident/i.test(M[1])) {
      tem=/\brv[ :]+(\d+)/g.exec(ua) || []; 
      return { name: 'IE', version:(tem[1] || '') };
    }

    if (M[1] === 'Chrome'){
      tem = ua.match(/\bOPR|Edge\/(\d+)/);
      if (tem!=null) { return { name:'Opera', version:tem[1] } };
    } 

    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) { M.splice(1,1,tem[1]) };

    return { name: M[0], version: +M[1] };
  }

  async getIPAddress() {
    const response = await this.cases.ipAddress().toPromise()
    return response.ip
  }

}
